import { render, staticRenderFns } from "./SingleSales.vue?vue&type=template&id=0c4e3f22&scoped=true&"
import script from "./SingleSales.vue?vue&type=script&lang=js&"
export * from "./SingleSales.vue?vue&type=script&lang=js&"
import style0 from "./SingleSales.vue?vue&type=style&index=0&id=0c4e3f22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4e3f22",
  null
  
)

component.options.__file = "SingleSales.vue"
export default component.exports